import React, { forwardRef, ForwardedRef, CSSProperties } from 'react';

const inputStyle: CSSProperties = {
  width: '100%',
  padding: '10px',
  height: '50px',
  paddingLeft: '40px',
  marginBottom: '24px',
  borderRadius: '10px',
  border: '1px solid #ccc', 
  fontSize: '16px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '10px center',
  backgroundSize: '20px',
};

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const EmailInput = forwardRef<HTMLInputElement, InputProps>((props, ref: ForwardedRef<HTMLInputElement>) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input 
        ref={ref}
        placeholder="Email"
        style={{
          ...inputStyle,
          backgroundImage: 'url("/person-icon.png")',
        }}
        type="email"
        autoComplete="email"
        {...props}
      />
    </div>
  );
});

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>((props, ref: ForwardedRef<HTMLInputElement>) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input 
        ref={ref}
        placeholder="Password"
        style={{
          ...inputStyle,
          width: "100%",
          backgroundImage: 'url("/password-icon.webp")',
        }}
        type="password"
        {...props}
      />
    </div>
  );
});

export const PhoneNumberInput = forwardRef<HTMLInputElement, InputProps>((props, ref: ForwardedRef<HTMLInputElement>) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input 
        ref={ref}
        placeholder="Phone Number"
        style={{
          ...inputStyle,
        }}
        type="tel"
        autoComplete="tel"
        pattern='[0-9]{10}'
        {...props}
      />
    </div>
  );
});